import { css } from 'lit';
export default css `
    :host {
        --list-item-icon-color: var(--color-primary);
        --list-item-align-items: center;

        display: block;
    }

    :host([has-icon]) .item {
        display: flex;
    }

    :host(:not([has-icon])) {
        padding-inline-start: calc(
            var(--list-item-icon-width) + var(--spacing-s)
        ); /* Same as icon width + icon spacing (gap) */
    }

    .item {
        align-items: var(--list-item-align-items);
        gap: var(--spacing-s);
    }

    .icon {
        --icon-color: var(--list-item-icon-color);

        position: relative;
        top: var(--spacing-xxxs);
    }

    /* Theme: blue */
    :host([theme='blue']) {
        --list-item-icon-color: var(--color-ui-08);

        color: var(--color-ui-08);
    }
`;
